import { useCallback, useState } from 'react';
import { IOption } from 'app/interfaces/customVariablesInterfaces';
import {
  ButtonPrimary,
  CustomInput,
  CustomSelect,
  TextM,
} from 'app/components';
import { formatPhone } from 'app/helpers';
import {
  StyledBox,
  StyledCtContainer,
  StyledSubtitle,
  StyledTitle,
} from '../ConsignedStep.styles';
import { ConsignedAuthorizationTypes } from '../interfaces';
import { isFullName } from 'app/utils/normalizer';
import { useSnackbar } from 'app/hooks/useSnackbar';
import { isValidEmail, isValidPhoneNumber } from 'app/utils/validations';

export interface IAuthorizationForm {
  type?: IOption;
  value?: string;
  name?: string;
  email?: string;
}

type IAuthorizationComponentProps = {
  sendTermAuthorization: (values: IAuthorizationForm) => void;
};

const AuthorizationComponent = ({
  sendTermAuthorization,
}: IAuthorizationComponentProps) => {
  const { showSnackbar } = useSnackbar();
  const [formValues, setFormValues] = useState<IAuthorizationForm>({
    type: {
      label: 'E-mail',
      value: ConsignedAuthorizationTypes.EMAIL,
    },
    value: undefined,
    email: undefined,
  });

  const isButtonDisabled =
    !formValues.name ||
    !isValidEmail(formValues?.email || '') ||
    (formValues.type?.value !== ConsignedAuthorizationTypes.EMAIL &&
      !isValidPhoneNumber(formValues?.value || ''));

  const sendTermHandler = useCallback(() => {
    if (!isFullName(formValues?.name)) {
      return showSnackbar(
        'O nome completo deve conter pelo menos dois nomes com mais de dois caracteres cada.',
        'error',
        10000,
      );
    }

    sendTermAuthorization(formValues);
  }, [formValues]);

  const getTitleHandler = useCallback(() => {
    return formValues.type?.label;
  }, [formValues]);

  return (
    <StyledCtContainer>
      <StyledTitle>Termo de aceite não assinado</StyledTitle>
      <StyledSubtitle>
        Para consultar a margem do tomador, é necessário que o Termo de Aceite
        esteja devidamente autorizado.
      </StyledSubtitle>

      <StyledBox>
        <div>
          <TextM style={{ marginBottom: '10px' }}>Nome completo* :</TextM>
          <CustomInput
            value={formValues?.name || ''}
            placeholder="Nome Completo"
            handleInputChange={(e) =>
              setFormValues({ ...formValues, name: e.target.value })
            }
          />
        </div>
        <div>
          <TextM style={{ marginBottom: '10px', marginTop: '1rem' }}>
            E-mail *
          </TextM>
          <CustomInput
            value={formValues?.email || ''}
            placeholder="exemplo@email.com"
            handleInputChange={(e) =>
              setFormValues({ ...formValues, email: e.target.value })
            }
          />
        </div>
        <div style={{ marginTop: '1rem' }}>
          <TextM style={{ marginBottom: '10px' }}>
            Enviar termo de aceite via *:
          </TextM>
          <CustomSelect
            value={formValues?.type}
            options={[
              {
                label: 'E-mail',
                value: ConsignedAuthorizationTypes.EMAIL,
              },
              { label: 'SMS', value: ConsignedAuthorizationTypes.SMS },
              {
                label: 'WhatsApp',
                value: ConsignedAuthorizationTypes.WHATSAPP,
              },
            ]}
            handleInputChange={(e) =>
              setFormValues({
                value: undefined,
                type: e.target.value,
                name: formValues.name,
                email: formValues.email,
              })
            }
            name="type"
            placeholder="Selecionar"
            isClearable={false}
          />
        </div>
        {formValues.type?.value !== ConsignedAuthorizationTypes.EMAIL && (
          <div style={{ marginTop: '1rem' }}>
            <TextM style={{ marginBottom: '10px' }}>{`${
              getTitleHandler() || 'Informação'
            } do solicitante: *`}</TextM>
            <CustomInput
              name="phone"
              value={formatPhone(formValues?.value || '')}
              handleInputChange={(e) =>
                setFormValues({ ...formValues, value: e.target.value })
              }
              placeholder="(00) 00000-0000"
            />
          </div>
        )}
        <ButtonPrimary
          disabled={isButtonDisabled}
          style={{ marginTop: '2rem' }}
          onClick={sendTermHandler}
        >
          Enviar termo de aceite
        </ButtonPrimary>
      </StyledBox>
    </StyledCtContainer>
  );
};

export default AuthorizationComponent;
